import { ChangeEvent, FC, ReactElement, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { FutureInputDecoration } from 'components/features/future/FutureInputDecoration/FutureInputDecoration'
import Checkbox from 'components/atoms/inputs/Checkbox'

export type LabeledCheckboxProps = {
  name: string
  label?: string
  error?: string
  className?: string
  labelClassName?: string
  onChange? (ev: ChangeEvent<HTMLInputElement>): void
}

export const LabeledCheckbox: FC<LabeledCheckboxProps> = ({
  label,
  error,
  name,
  className,
  labelClassName,
  onChange,
}): ReactElement => {
  const { register, clearErrors, formState: { errors }} = useFormContext()
  const fieldErrorMessage = errors[name]?.message

  const handleOnChange = useCallback((ev: ChangeEvent<HTMLInputElement>): void => {
    clearErrors(name)
    onChange?.(ev)
  }, [name, clearErrors, onChange])

  return (
    <FutureInputDecoration
      error={ error || fieldErrorMessage }
      className={ className }
    >
      <Checkbox
        label={ label }
        name={ name }
        labelClassName={ labelClassName }
        register={ register }
        onChange={ handleOnChange }
      />
    </FutureInputDecoration>
  )
}
